import React from "react";
import { Typography, Breadcrumbs, Box } from "@material-ui/core";
import { Link } from "react-router-dom";
import { useTranslation } from "../../langs/useTranslation";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import { HomeOutlined } from "@material-ui/icons";

/**
 *
 * @param routes {Array<{name: string, to: string}>}
 * @constructor
 */
const BreadCrumbs = (routes=[]) => props => {
  const {
    pageName,
  } = props;

  return (
    <Breadcrumbs
      separator={<NavigateNextIcon fontSize="small" />}
      aria-label="breadcrumb"
    >
      <Link color="inherit" to="/dashboard">
        <HomeOutlined />
        Home
      </Link>
      { routes.map(route => {
        return (
          <Link color="inherit" to={route.to} key={route.name+route.to}>
            {route.name}
          </Link>
        )
      })}
      <Typography color="textPrimary">
       {pageName}
      </Typography>
    </Breadcrumbs>
  );
};

export default BreadCrumbs